import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from '../../../../services/auth/authentication.service';
import { Router } from '@angular/router';
import { TokenStorage } from '../../../../storages/token.storage';
import { NavbarInfoService } from '../../../home/services/navbar-info.service';


@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.sass']
})
export class LoginFormComponent implements OnInit {

  username: string;
  password: string;

  @Output()
  authEvent: EventEmitter<any> = new EventEmitter();

  @Output()
  clearMessageEvent: EventEmitter<boolean> = new EventEmitter();

  constructor(private router: Router, private auhenticationService: AuthenticationService, private token: TokenStorage, private info: NavbarInfoService) { 
  }

  ngOnInit() {
    $('#navbar').hide();
  }

  login(): void {
    this.clearMessageEvent.emit(true);
    window.localStorage.clear();

    this.auhenticationService.attemptAuth(this.username, this.password).subscribe(
      data => {
        this.token.saveToken(data);
        this.getPerson();
      }, err => {
        this.username = '';
        this.password = '';
        this.authEvent.emit(err);
      }
    );
  }

  getPerson(){
    this.info.get().subscribe(info => {
      if (info != null) {
        this.token.setRole(info);

        document.getElementById("userName").textContent = info["name"];

        this.router.navigate(['home']);
      }
    });
    
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/components/login-form/login-form.component.ts